import React from "react";
import ReactDom from "react-dom";
import "./math-polyfill";

export default class FilmStrip extends React.Component {
    constructor(props) {
        super(props);

        this.state = { currentPage: 0, itemsPerPage: 0, totalPages: 0 };

        this.onPrev = this.onPrev.bind(this);
        this.onNext = this.onNext.bind(this);
        this.onSelectedItemChange = this.onSelectedItemChange.bind(this);
    }

    componentDidMount() {
        const itemsPerPage = Math.floor((ReactDom.findDOMNode(this.refs.slider).getBoundingClientRect().width / this.thumbWidth));
        const totalPages = Math.ceil(this.props.thumbnails.length / itemsPerPage);
        this.setState({ ...this.state, itemsPerPage, totalPages });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.value !== this.props.value) {
            const { itemsPerPage } = this.state;
            this.setState({ currentPage: Math.trunc(this.props.value / itemsPerPage) });
        }
    }

    onNext() {
        this.setState((prev) => {
            return { currentPage: Math.min(prev.currentPage + 1, prev.totalPages - 1) };
        });
    };

    onSelectedItemChange(index) {
        this.props.onChange && this.props.onChange(index);
    }

    onPrev() {
        this.setState((prev) => {
            return { currentPage: Math.max(prev.currentPage - 1, 0) };
        });
    };

    get thumbWidth() {
        return 115;
    }

    render() {
        const { currentPage, itemsPerPage, totalPages } = this.state;
        const pageWidth = ((itemsPerPage * this.thumbWidth) * currentPage) * -1;
        const styles = {
            transform: `translate3d(${pageWidth}px, 0px, 0px)`,
            width: (this.props.thumbnails.length * this.thumbWidth) + "px"
        };

        const thumbnails = this.props.thumbnails.map((thumb, index) => (
            <div key={index} className={"film-strip-item " + (this.props.value === index ? "active " : "") + thumb.type.toLowerCase()}
                onClick={e => this.onSelectedItemChange(index)}
            >
                <img alt="" src={thumb.thumbnailUrl} />
                <div className={("film-strip-item-overlay-" + thumb.type.toLowerCase())}>
                    <div>{thumb.description}</div>
                </div>
            </div>
        ));

        return (
            <div className="film-strip" ref="slider">
                <div className="film-strip-inner" ref="innerSlider" style={styles}>
                    {thumbnails}
                </div>
            </div>
        );
    }
}